import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import Spinner from '../Spinner/Spinner'
import { Input } from 'reactstrap'
import { ALL_STATISTICS_QUERY } from '../../graphql'

const ALL_STATISTICS = gql(ALL_STATISTICS_QUERY)

export default function EventSelect({ value, handleChange }) {
  console.log(`EventSelect rendered value: ${value}`)

  const { loading, error, data } = useQuery(ALL_STATISTICS, { fetchPolicy: 'cache-first' })
  if (loading) {
    return <Spinner />
  }
  if (error) {
    return error.message
  }

  return (
    <Input type="select" name="eventId" id="event" bsSize="sm" value={value} onChange={handleChange}>
      <option key={-1} value="">All Events</option>
      {data.allStatistics.map(stat => (
        <option key={stat.id} value={stat.id}>
          {stat.name}
        </option>
      ))}
    </Input>
  )
}